export default __webpack_public_path__ + "hamburger.549ea7.svg";